import { render } from "./RedirectToBank.vue?vue&type=template&id=46818f4b"
import script from "./RedirectToBank.vue?vue&type=script&lang=js"
export * from "./RedirectToBank.vue?vue&type=script&lang=js"

import exportComponent from "/media/ehsan/projects/Projects/iranget-v9/vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__